// Daftar elemen dan topik per mapel, dipakai validasi konten, halaman admin, dan statistik.
// Sengaja hanya data (tanpa generator) supaya server bisa memuatnya dengan ringan.
import { TOPIK_MATEMATIKA } from './matematika/topik.js';
import { TOPIK_BI, ELEMEN_BI } from './bahasa-indonesia/topik.js';

export const ELEMEN_MATEMATIKA = ['Bilangan', 'Geometri & Pengukuran', 'Data'];
export const ELEMEN_PER_MAPEL = { matematika: ELEMEN_MATEMATIKA, 'bahasa-indonesia': ELEMEN_BI };
export const TOPIK_PER_MAPEL = { matematika: TOPIK_MATEMATIKA, 'bahasa-indonesia': TOPIK_BI };
// Mapel yang belum terdaftar memakai elemen Matematika (perilaku lama).
export const elemenUntuk = mapel => ELEMEN_PER_MAPEL[mapel] || ELEMEN_MATEMATIKA;

/** Nama topik dari kunci generator/topik, di mapel mana pun. */
export function namaTopik(kunci) {
  const k = String(kunci || '').replace(/^bank:/, '');
  for (const t of Object.values(TOPIK_PER_MAPEL)) if (t[k]) return t[k].nama;
  return null;
}
